import axios from "axios";
import {
  USER_CREATE_REQUEST,
  USER_CREATE_SUCCESS,
  USER_CREATE_FAIL,
  ALL_USER_VIEW_REQUEST,
  ALL_USER_VIEW_SUCCESS,
  ALL_USER_VIEW_FAIL,
  ALL_CUSTOMERS_VIEW_REQUEST,
  ALL_CUSTOMERS_VIEW_SUCCESS,
  ALL_CUSTOMERS_VIEW_FAIL,
  ALL_DRIVERS_VIEW_REQUEST,
  ALL_DRIVERS_VIEW_SUCCESS,
  ALL_DRIVERS_VIEW_FAIL,
  ALL_DRIVER_VIEW_REQUEST,
  ALL_DRIVER_VIEW_SUCCESS,
  ALL_DRIVER_VIEW_FAIL,
  CUSTOMERS_BY_ID_SUCCESS,
  USER_BY_ID_SUCCESS,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAIL,
  SERVERADDRESS,
} from "../constants";
// import { notifyFailure, notifySuccess } from "../components/toast";

export const createUser =
  (obj, callback, setReservationId) => async (dispatch) => {
    dispatch({
      type: USER_CREATE_REQUEST,
    });
    try {
      const { data } = await axios.post(`${SERVERADDRESS}/v1/users/`, obj);
      dispatch({
        type: USER_CREATE_SUCCESS,
        payload: data,
      });
      callback && callback(data.id);
    } catch (err) {
      //   notifyFailure(err.response.data.message);
      dispatch({
        type: USER_CREATE_FAIL,
        payload: err,
      });
    }
  };

export const getUsers = (obj, callback) => async (dispatch) => {
  dispatch({
    type: ALL_USER_VIEW_REQUEST,
  });
  try {
    const { data } = await axios.get(
      //   `${SERVERADDRESS}/v1/user/getUsers` ?????,
      `${SERVERADDRESS}/v1/users?limit=20&role=user`,
      obj
    );

    localStorage.setItem("users", JSON.stringify(data));
    // localStorage.setItem("users", JSON.stringify(data.slice(0, 200)));
    dispatch({
      type: ALL_USER_VIEW_SUCCESS,
      payload: data,
      // payload: data.slice(0, 200),
    });
    // callback && callback(data);
  } catch (err) {
    // console.log(err);
    dispatch({
      type: ALL_USER_VIEW_FAIL,
      payload: err,
    });
  }
};
export const getDrivers = (obj, callback) => async (dispatch) => {
  dispatch({
    type: ALL_DRIVER_VIEW_REQUEST,
  });
  try {
    const { data } = await axios.get(
      //`${SERVERADDRESS}/v1/user/getUsers` ?????,
      `${SERVERADDRESS}/v1/users?limit=20&role=driver`,
      obj
    );

    localStorage.setItem("driver", JSON.stringify(data));
    // localStorage.setItem("users", JSON.stringify(data.slice(0, 200)));
    dispatch({
      type: ALL_DRIVER_VIEW_SUCCESS,
      payload: data,
      // payload: data.slice(0, 200),
    });
    // callback && callback(data);
  } catch (err) {
    // console.log(err);
    dispatch({
      type: ALL_DRIVER_VIEW_FAIL,
      payload: err,
    });
  }
};

export const setUserData = (obj) => async (dispatch) => {
  dispatch({
    type: CUSTOMERS_BY_ID_SUCCESS,
    payload: obj,
  });
};

export const getAllCustomers = (obj, callback) => async (dispatch) => {
  dispatch({
    type: ALL_CUSTOMERS_VIEW_REQUEST,
  });
  try {
    const { data } = await axios.post(
      `${SERVERADDRESS}/v1/users/getAllCustomers`,
      obj
    );
    localStorage.setItem("allCustomers", JSON.stringify(data));
    dispatch({
      type: ALL_CUSTOMERS_VIEW_SUCCESS,
      payload: data,
    });
  } catch (err) {
    // console.log(err);
    dispatch({
      type: ALL_CUSTOMERS_VIEW_FAIL,
      payload: err,
    });
  }
};
export const getAllDrivers = (obj, callback) => async (dispatch) => {
  dispatch({
    type: ALL_DRIVERS_VIEW_REQUEST,
  });
  try {
    const { data } = await axios.post(
      `${SERVERADDRESS}/v1/users/getAllDrivers`,
      obj
    );
    localStorage.setItem("allDrivers", JSON.stringify(data));
    dispatch({
      type: ALL_DRIVERS_VIEW_SUCCESS,
      payload: data,
    });
  } catch (err) {
    // console.log(err);
    dispatch({
      type: ALL_DRIVERS_VIEW_FAIL,
      payload: err,
    });
  }
};

export const updateUserById = (obj, id, handleSuccess) => async (dispatch) => {
  dispatch({
    type: USER_UPDATE_REQUEST,
  });
  try {
    const { data } = await axios.patch(`${SERVERADDRESS}/v1/users/` + id, obj);
    handleSuccess();
    // notifySuccess("Updated successfully !");
    dispatch({
      type: USER_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (err) {
    // console.log(err);
    // notifyFailure(err?.response?.data?.message);
    dispatch({
      type: USER_UPDATE_FAIL,
      payload: err,
    });
  }
};
